/**
 * Shared constants for the frontend.
 * Keep in sync with api/lib/constants.js
 */

export const MIN_WITHDRAWAL_AMOUNT = 100;

/** Withdrawals are only allowed from this day to end of month (normally 10; temporarily 1) */
export const WITHDRAWAL_OPEN_DAY = 1;
